import { create } from "zustand";
import { devtools } from "zustand/middleware";
import notifications from "./data/notification";

const useStore = create(
  devtools((set) => ({
    avatar: localStorage.getItem("userAvatar") || "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png",
    menuOpen: false,
    counter: {
      value: 0,
      status: "idle",
    },
    domains: {
      data: [],
      loading: true,
      error: null,
      meta: null,
    },
    agency: {
      agencyData: {},
      loading: true,
      error: null,
    },
    project: {
      projectData: {
        files: [],
        template_file: null,
      },
      loading: true,
      error: null,
    },
    _project: {
      projectData: [],
      loading: true,
      error: null,
    },
    tutorial: {
      tutorialData: {},
      loading: true,
      error: null,
    },
    myAgency: {
      myAgency: [],
      loading: true,
      error: null,
      meta: {},
      user: {},
    },
    projects: {
      projects: [],
      loading: true,
      error: null,
    },
    tutorials: {
      tutorials: [],
    },
    notifications: notifications,
    avatarUpdateTrigger: false,

    setAvatar: (avatar) => set({ avatar }),
    setMenuOpen: (open) => set({ menuOpen: open }),
    setCounter: (count) => set({ counter: count }),
    setDomains: (domains) => set({ domains: domains }),
    setAgency: (agency) => set({ agency: agency }),
    setMyAgency: (myAgency) => set({ myAgency: myAgency }),
    setProject: (project) => set({ project: project }),
    set_Project: (project) => set({ _project: project }),
    setProjects: (projects) => set({ projects: projects }),
    setTutorial: (tutorial) => set({ tutorial: tutorial }),
    setTutorials: (tutorials) => set({ tutorials: tutorials }),
    setNotifications: (notifications) => set({ notifications: notifications }),
    setAvatarUpdateTrigger: (value) => set({ avatarUpdateTrigger: value }),
  })),
);

export default useStore;
